import { Component, inject } from '@angular/core';
import { RouterOutlet, RouterLink } from '@angular/router';
import { ThemeToggleService } from '../../partials/theme-toggle/theme-toggle.service';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [RouterOutlet, RouterLink],
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  host: { 'class': 'block min-h-screen w-full bg-background' }
})
export class AuthComponent {
  themeService = inject(ThemeToggleService);
}